import React from 'react'

import styled from '@emotion/styled'

import { ArcadeDivider, colors, PaddingInset, spacing } from '@cash-design-system/react'
import {
  FormBlockerElementDividerElement,
  FormBlockerElementDividerElementDividerStyle,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'

const StyleToHeightMap: Record<FormBlockerElementDividerElementDividerStyle, string> = {
  [FormBlockerElementDividerElementDividerStyle.ELEMENT]: spacing.m,
  [FormBlockerElementDividerElementDividerStyle.SECTION]: spacing.xl,
  [FormBlockerElementDividerElementDividerStyle.HAIRLINE]: '1px',
}

const StyledDivider = styled.div<{ height?: string }>`
  width: 100%;
  background-color: ${colors.nestedCardOutlineActive.light};
  height: ${props => props.height};
  margin: ${props => props.theme.spacing.s} 0;
`

/**
 * A divider line between two other elements. This line is displayed in gray and spans
 * the full width of the screen, defaults to a HAIRLINE divider.
 */
export function DividerElement(props: FormBlockerElementDividerElement): React.ReactElement {
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  // after the migration to Arcade different widths of dividers are not supported
  // FixedSpacerElement will be used instead.
  if (isArcadeMigrationEnabled) return <ArcadeDivider />
  return (
    <PaddingInset>
      <StyledDivider
        data-testid="divider"
        height={StyleToHeightMap[props.style || FormBlockerElementDividerElementDividerStyle.HAIRLINE]}
      />
    </PaddingInset>
  )
}
